export default [
    {
        "id": "product-presentation",
        "plugin": "ProductPresentation",
        "pluginId": 4,
        "name": "product-presentation",
        "config": `{"IncludeGroup":true}`,
        "predefinedPlugin": {
            "plugin": "UserFeedback",
            "pluginId": 9,
            "name": "feedback",
            "config": `{"GET_pageId":"rvPageId"}`
        },
        "predefinedPlugin2": {
            "plugin": "NewPromo",
            "pluginId": 1,
            "name": "new-product",
        },
        "relatedBanner": "SizeTable",
        "html": require('./product-presentation/html').default
    }
]